jQuery(function($) {

    $(".testimonialSlider .slidesWrapper").each(function () {
        if ($(this).children().length > 1) {
            $(this).addClass('owl-carousel owl-theme').owlCarousel({
                nav: false,
                autoplay: true,
                items: 1,
                smartSpeed: 400,
                autoHeight: true,
                dots: true,
                loop: true,
            });
        }
    });

});
